
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PluginDialog extends SiteEntityDialog<PluginRow, any> {
        protected getFormKey() { return PluginForm.formKey; }
        protected getIdProperty() { return PluginRow.idProperty; }
        protected getLocalTextPrefix() { return PluginRow.localTextPrefix; }
        protected getNameProperty() { return PluginRow.nameProperty; }
        protected getService() { return PluginService.baseUrl; }

        protected form = new PluginForm(this.idPrefix);

        constructor(options?: any) {
            super(options);

            this.form.ProgrammingLanguage.change(() => {
                this.form.SourceCode.setLanguage(this.form.ProgrammingLanguage.value);
            });

            this.form.SupportedLang.change(() => {
                this.form.ProgrammingLanguage.value = SupportedLanguage[this.form.SupportedLang.value];
                this.form.ProgrammingLanguage.element.triggerHandler("change");
            });
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.SupportedLang.value = SupportedLanguage[this.form.ProgrammingLanguage.value];
            
        }

        protected updateInterface() {
            super.updateInterface();

            this.cloneButton.hide();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
            this.form.SourceCode.setLanguage(this.form.ProgrammingLanguage.value);
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 370;
            this.form.SourceCode.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }
    }
}